import { IconButton, useColorMode, Tooltip } from '@chakra-ui/react';
import { MdLightMode, MdDarkMode } from 'react-icons/md';

export const ColorModeSwitcher = () => {
  const { colorMode, toggleColorMode } = useColorMode();

  return (
    <Tooltip
      label={colorMode === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
      placement="bottom"
    >
      <IconButton
        aria-label={colorMode === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
        icon={colorMode === 'light' ? <MdDarkMode size={20} /> : <MdLightMode size={20} />}
        onClick={toggleColorMode}
        variant="ghost"
        size="md"
        color="text-primary"
        _hover={{
          bg: 'interactive-hover',
        }}
      />
    </Tooltip>
  );
};
